'use strict';

var react = require('react');

// src/hooks/useStorageState.ts
var useStorageState = (key, defaultValue) => {
  const [state, setState] = react.useState(defaultValue);
  react.useEffect(() => {
    const initDefaultValue = async () => {
      const data = localStorage.getItem(key);
      if (data) {
        setState(JSON.parse(data));
      } else {
        setState(defaultValue);
        updateState(defaultValue);
      }
    };
    initDefaultValue();
  }, [key]);
  const updateState = async (newValue) => {
    localStorage.setItem(key, JSON.stringify(newValue));
    setState(newValue);
  };
  return { state, updateState };
};

exports.useStorageState = useStorageState;
